/**
 * Determines if a file type can be previewed based on its extension
 * Any updates here should be updated in FilePreview and vice versa
 */
export const isFileTypePreviewable = (fileExtension: string): boolean => {
  const extension = fileExtension.split(".").pop()?.toLowerCase();

  const previewableExtensions = [
    // Documents
    "txt",
    "json",
    "pdf",
    // Images
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "webp",
    // Videos
    "mp4",
    "webm",
    "ogg",
    // Audio
    "mp3",
    "wav",
    "aac",
    "flac",
  ];

  return previewableExtensions.includes(extension || "");
};
